// Import the functions you need from the SDKs you need
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: "links-magazin.firebaseapp.com",
  projectId: "links-magazin",
  storageBucket: "links-magazin.appspot.com",
  messagingSenderId: "219322085144",
  appId: "1:219322085144:web:d49221b509fe8545d6b86d",
  measurementId: "G-JLK29HB9ZQ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestore = getFirestore();
const storage = getStorage();
const analytics = getAnalytics(app);

export { firestore, storage, app };
